/* global $ */

import googleMapsApiLoader from 'google-maps-api-loader';

let googleApi;
let places;
let placeListEl;
let placeEls;
let map;
let geocoder;
let infoWindow;
let initialSearchTerm;
const bounds = {};


function init() {

	const mapScreenEl = document.querySelector('.map-screen');

	if (!mapScreenEl) {
		return;
	}

	places = JSON.parse(document.getElementById('map-screen__places-data').innerHTML);
	placeListEl = document.querySelector('.map-screen__place-list-items');
	placeEls = placeListEl && placeListEl.children;

	$('.map-screen__tab a').on('click', (event) => {
		event.preventDefault();
		const id = event.currentTarget.hash.replace('#', '');
		selectTab(id);
	});

	googleMapsApiLoader({
		libraries: ['places'],
		apiKey: 'AIzaSyAgYWo4_VL_oAbM0ARvq6rStRUN1deK7R0'
	}).then((api) => {
		googleApi = api;
		initSearch();
		return googleApi;
	}).then(() => (

		new Promise((resolve, reject) => {

			const url = new URL(window.location.href);
			const params = new URLSearchParams(url.search);

			initialSearchTerm = params.get('place_id');

			geocoder = new googleApi.maps.Geocoder();

			geocoder.geocode({ address: 'Finland' }, (results, status) => {
				if (status === googleApi.maps.GeocoderStatus.OK) {
					// map.setCenter(results[0].geometry.location);
					bounds.finland = results[0].geometry.bounds;
					resolve(initialSearchTerm);
				} else {
					// console.warn('Geocoding failed', status);
					reject(status);
				}
			});


		})

	)).then((initialSearchTerm) => {

		map = new googleApi.maps.Map(document.getElementById('map-screen__map-canvas'), {});
		infoWindow = new googleApi.maps.InfoWindow();
		bounds.markers = new googleApi.maps.LatLngBounds();

		places.forEach((place) => {

			const marker = createMarker(place);

			marker.setMap(map);
			bounds.markers.extend(marker.getPosition());

			place.marker = marker;
			place.slipEl = document.getElementById(`place-slip--${place.id}`);
			place.infoWindowEl = document.getElementById(`place-infowindow--${place.id}`);

			marker.addListener('click', () => {
				unselectPlace();
				selectPlace(getIdByMarker(marker));
			});

			return marker;

		});

		infoWindow.addListener('closeclick', () => {
			unselectPlace();
		});

		map.fitBounds(bounds.finland);

		if (initialSearchTerm) {
			geocoder.geocode({ placeId: initialSearchTerm }, (results, status) => {
				if (status === googleApi.maps.GeocoderStatus.OK) {
					doSearch(results[0]);
				} else {
					// console.warn('Geocoding failed', status);
				}
			});
		}

	}, (err) => {
		// console.error(err);
	});

	Array.from(placeEls).forEach((el) => {

		const linkEl = el.querySelector('[data-action="activate"]');
		// const placeLink = linkEls[0];
		// const mapLink = linkEls[1];

		linkEl.addEventListener('click', (event) => {
			event.preventDefault();
			unselectPlace();
			selectTab('kartta');
			selectPlace(parseInt(linkEl.getAttribute('data-id'), 10), true);
		});

	});

}



function createMarker(place) {

	return new googleApi.maps.Marker({
		position: {
			lat: parseFloat(place.location.lat),
			lng: parseFloat(place.location.lng)
		},
		title: place.title
	});

}

// function getMarkerById(placeID) {
// 	return places.find((place) => place.id === placeID).marker;
// }

function getIdByMarker(marker) {
	return places.find((place) => place.marker === marker).id;
}

function selectPlace(placeID, shouldPan) {

	const place = places.find((place) => place.id === placeID);
	const marker = place.marker;

	place.slipEl.classList.add('is--active');

	infoWindow.setContent(place.infoWindowEl.cloneNode(true));
	infoWindow.open(map, marker);

	if (shouldPan) {

		map.panTo(marker.getPosition());

		if (map.getZoom() < 10) {
			map.setZoom(10);
		}

	}

}

function unselectPlace() {
	Array.from(placeEls).forEach((el) => el.firstElementChild.classList.remove('is--active'));
	infoWindow.close();
}

function selectTab(id) {

	const $tabs = $('.map-screen__tab');
	const $panes = $('.map-screen__col');

	$tabs.removeClass('is--active');
	$panes.removeClass('is--active');

	$tabs.filter(`[href="${id}"]`).addClass('is--active');
	$panes.filter(`#${id}`).addClass('is--active');

}

/*
 * Search
 */

let mapSearchEl;
let searchInputEl;

function initSearch() {

	mapSearchEl = document.querySelector('.map-screen__search');
	searchInputEl = mapSearchEl.querySelector('input[type="text"]');

	const autocomplete = new googleApi.maps.places.Autocomplete(searchInputEl, {
		types: ['(cities)'],
		componentRestrictions: {
			country: 'fi'
		}
	});

	let autocompletePlace;

	mapSearchEl.querySelector('form').addEventListener('submit', (event) => {
		event.preventDefault();
		if (!searchInputEl.value.trim()) {
			resetSearch();
		} else if (autocompletePlace && autocompletePlace.geometry) {
			doSearch(autocompletePlace);
		} else {
			searchInputEl.focus();
		}
	});

	mapSearchEl.querySelector('form').addEventListener('reset', resetSearch);

	searchInputEl.addEventListener('change', () => {
		autocompletePlace = null;
	});

	document.querySelector('.map-screen__place-list__empty-msg button').addEventListener('click', () => {
		mapSearchEl.querySelector('form').reset();
	});

	autocomplete.addListener('place_changed', () => {
		autocompletePlace = autocomplete.getPlace();
	});

}

function resetSearch() {
	places.forEach((place) => {
		place.slipEl.parentElement.classList.toggle('is--hidden', false);
		place.marker.setMap(map);
	});
	placeListEl.classList.toggle('search--empty', false);
	document.querySelector('.map-screen__place-list-header h3 span:nth-child(1)').textContent = '';
	document.querySelector('.map-screen__place-list-header h3 span:nth-child(2)').textContent = places.length;
}

function doSearch(autocompletePlace) {

	const locality = (function () {
		if (
			Array.isArray(autocompletePlace.address_components)
			&& autocompletePlace.address_components[0]
		) {
			return autocompletePlace.address_components[0].long_name;
		} else {
			return autocompletePlace.name;
		}
	}());

	const localityBounds = new googleApi.maps.LatLngBounds();
	const activePlaces = places.filter((place) => (place.locality === locality));

	places.forEach((place) => {

		const isActive = (place.locality === locality);

		place.slipEl.parentElement.classList.toggle('is--hidden', !isActive);

		if (isActive) {
			localityBounds.extend(place.marker.getPosition());
			place.marker.setMap(map);
		} else {
			place.marker.setMap(null);
		}

	});

	document.querySelector('.map-screen__place-list-header h3 span:nth-child(1)').textContent = locality;
	document.querySelector('.map-screen__place-list-header h3 span:nth-child(2)').textContent = activePlaces.length;

	if (activePlaces.length) {
		map.fitBounds(localityBounds);
	} else {
		map.setCenter(autocompletePlace.geometry.location);
		map.setZoom(11);
	}

	placeListEl.classList.toggle('search--empty', !activePlaces.length);

	if (map.getZoom() > 11) {
		map.setZoom(11);
	}

	if (!searchInputEl.value.trim()) {
		searchInputEl.value = locality;
	}

}

export default {
	init
};
